import { createAsyncThunk } from "@reduxjs/toolkit";
import aiGatewayAPI from "services/api/aiGateway";
import coreAPIs from "services/api/core";

import magnifiAPI from "../../services/api/magnifi";

export const getStreams = createAsyncThunk("stream/getStreams", async (payload) => {
  try {
    const response = await magnifiAPI.getStreams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const v2GetStreams = createAsyncThunk("stream/v2GetStreams", async (payload) => {
  try {
    const response = await magnifiAPI.v2GetStreams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getStreamsByIds = createAsyncThunk("stream/getStreamsByIds", async (payload) => {
  try {
    const response = await magnifiAPI.getStreamsByIds(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getStreamDetails = createAsyncThunk("stream/getStreamDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getStreamDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const v2GetStreamDetails = createAsyncThunk("stream/v2GetStreamDetails", async (payload) => {
  try {
    const response = await magnifiAPI.v2GetStreamDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateStream = createAsyncThunk("stream/updateStream", async (payload) => {
  try {
    const response = await magnifiAPI.updateStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const reTriggerStream = createAsyncThunk("stream/reTriggerStream", async (payload) => {
  try {
    const response = await magnifiAPI.reTriggerStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportJSONStream = createAsyncThunk("stream/exportJSONStream", async (payload) => {
  try {
    const response = await magnifiAPI.exportJSONStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportTimestampJSONStream = createAsyncThunk("stream/exportTimestampJSONStream", async (payload) => {
  try {
    const response = await magnifiAPI.exportTimestampJSONStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportJSONStreamMetadata = createAsyncThunk("stream/exportJSONMetadataStream", async (payload) => {
  try {
    const response = await magnifiAPI.exportJSONStreamMetadata(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportStreamReport = createAsyncThunk("stream/exportStreamReport", async (payload) => {
  try {
    const response = await magnifiAPI.exportStreamReport(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportStreamClipsXlsx = createAsyncThunk("stream/exportStreamClipsXlsx", async (payload) => {
  try {
    const response = await magnifiAPI.exportStreamClipsXlsx(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportEventsJSON = createAsyncThunk("stream/exportEventsJSON", async (payload) => {
  try {
    const response = await magnifiAPI.exportEventsJSON(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getCopiedStreamCount = createAsyncThunk("stream/getCopiedStreamCount", async (payload) => {
  try {
    const response = await magnifiAPI.getCopiedStreamCount(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getStreamClipFilters = createAsyncThunk("stream/getStreamClipFilters", async (payload) => {
  try {
    const response = await magnifiAPI.getStreamClipFilters(payload);

    return { ...response.data, streamId: payload.streamId };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteStream = createAsyncThunk("stream/deleteStream", async (payload) => {
  try {
    const response = await magnifiAPI.deleteStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getEventsByCategory = createAsyncThunk(`stream/getEventsByCategory`, async (payload) => {
  try {
    const response = await magnifiAPI.getEventsByCategory(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getEventTagsById = createAsyncThunk(`stream/getEventTagsById`, async (payload) => {
  try {
    const response = await magnifiAPI.getEventTagsById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllRatingRule = createAsyncThunk(`stream/getAllRatingRule`, async (payload) => {
  try {
    const response = await magnifiAPI.getAllRatingRule(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const convertHLSToMP4 = createAsyncThunk(`stream/initiateRequestForHLSToMP4`, async (payload) => {
  try {
    const response = await magnifiAPI.initiateRequestForHLSToMP4(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateStreams = createAsyncThunk("stream/validateStreams", async (payload) => {
  try {
    const response = await magnifiAPI.validateStreams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getUsageCSVReport = createAsyncThunk(`stream/getUsageCSVReport`, async (payload) => {
  try {
    const response = await magnifiAPI.getUsageCSVReport(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateStream = createAsyncThunk(`stream/validateStream`, async (payload) => {
  try {
    const response = await magnifiAPI.validateStream(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getHLSToMP4VideoDetails = createAsyncThunk(`stream/getHLSToMP4VideoDetails`, async (payload) => {
  try {
    const response = await magnifiAPI.getHLSToMP4VideoDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteHLSToMP4Data = createAsyncThunk(`stream/deleteHLSToMP4Data`, async (payload) => {
  try {
    const response = await magnifiAPI.deleteHLSToMP4Data(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getStreamsListByUrl = createAsyncThunk(`stream/getStreamsListByUrl`, async (payload) => {
  try {
    const response = await magnifiAPI.getStreamsListByUrl(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const sentToClientWebhook = createAsyncThunk(`stream/sentToClientWebhook`, async (payload) => {
  try {
    const response = await magnifiAPI.sentToClientWebhook({ payload });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const editStream = createAsyncThunk(`stream/editStream`, async (payload) => {
  try {
    const response = await magnifiAPI.editStream({ payload });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const createStream = createAsyncThunk(`stream/createStream`, async (payload) => {
  try {
    const response = await magnifiAPI.createStream(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const createPreStreamTemplate = createAsyncThunk(`stream/createPreStreamTemplate`, async (payload) => {
  try {
    const response = await magnifiAPI.createPreStreamTemplate(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getPreStreamTemplates = createAsyncThunk(`stream/getPreStreamTemplates`, async (payload) => {
  try {
    const response = await magnifiAPI.getPreStreamTemplates(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const updatePreStreamTemplate = createAsyncThunk(`stream/updatePreStreamTemplate`, async (payload) => {
  try {
    const response = await magnifiAPI.updatePreStreamTemplate(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const deletePreStreamTemplate = createAsyncThunk(`stream/deletePreStreamTemplate`, async (payload) => {
  try {
    const response = await magnifiAPI.deletePreStreamTemplate(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const addClipNamingTemplateIdToStream = createAsyncThunk(
  `stream/addClipNamingTemplateIdToStream`,
  async (payload) => {
    try {
      const response = await magnifiAPI.addClipNamingTemplateIdToStream(payload);

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getStreamDetailsByStreamId = createAsyncThunk(`stream/getStreamDetailsByStreamId`, async (payload) => {
  try {
    const response = await magnifiAPI.getStreamDetailsByStreamId(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamClipSuggestions = createAsyncThunk(`stream/getStreamClipSuggestions`, async (payload) => {
  try {
    const response = await magnifiAPI.getStreamClipSuggestions(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamClipSuggestionsByTime = createAsyncThunk(
  `stream/getStreamClipSuggestionsByTime`,
  async (payload) => {
    try {
      const response = await magnifiAPI.getStreamClipSuggestionsByTime(payload);

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const saveStreamClipSuggestions = createAsyncThunk(`stream/saveStreamClipSuggestions`, async (payload) => {
  try {
    const response = await magnifiAPI.saveStreamClipSuggestions(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const deleteStreamClipSuggestions = createAsyncThunk(`stream/deleteStreamClipSuggestions`, async (payload) => {
  try {
    const response = await magnifiAPI.deleteStreamClipSuggestions(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const updateStreamClipSuggestions = createAsyncThunk(`stream/updateStreamClipSuggestions`, async (payload) => {
  try {
    const response = await magnifiAPI.updateStreamClipSuggestions(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const downloadStream = createAsyncThunk(`stream/downloadStream`, async (payload) => {
  try {
    const response = await coreAPIs.downloadStream(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamDownloadLink = createAsyncThunk(`stream/getStreamDownloadLink`, async (payload) => {
  try {
    const response = await coreAPIs.getDownloadUrl(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamByClipId = createAsyncThunk(`stream/getStreamByClipId`, async (payload) => {
  try {
    const response = await magnifiAPI.getStreamByClipId(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getMatchJobDetails = createAsyncThunk(`stream/getMatchJobDetails`, async (payload) => {
  try {
    const response = await coreAPIs.getMatchJobDetails(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamMatchJobDetails = createAsyncThunk(`stream/getStreamMatchJobDetails`, async (payload) => {
  try {
    const response = await coreAPIs.getStreamMatchJobDetails(payload);

    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const stopStreamMatchJob = createAsyncThunk(`stream/stopStreamMatchJob`, async (payload) => {
  try {
    const response = await coreAPIs.stopStreamMatchJob(payload);

    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const deleteStreamMatchJobDetails = createAsyncThunk(`stream/deleteStreamMatchJobDetails`, async (payload) => {
  try {
    const response = await coreAPIs.deleteStreamMatchJobDetails(payload);

    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getDatafeedStreams = createAsyncThunk(`stream/getDatafeedStreams`, async (payload) => {
  try {
    const response = await magnifiAPI.getDatafeedStreams(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getStreamCategoryById = createAsyncThunk(
  "stream/getStreamCategoryById",
  async (streamId, { getState }) => {
    const state = getState();
    const category = state?.stream?.entities?.[streamId]?.category;

    return category;
  },
);

export const getChapterizeLanguages = createAsyncThunk("stream/getChapterizeLanguages", async () => {
  try {
    const response = await aiGatewayAPI.getChapterizeLanguages();

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const coreStreamsValidate = createAsyncThunk(`stream/coreStreamsValidate`, async (payload) => {
  try {
    const response = await coreAPIs.streamsValidate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
